import { Component, input, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { NavbarComponent } from '../navbar/navbar.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { UiStore } from '../../../store/ui';
import { ScreenSpinnerComponent } from '../../screen-spinner/screen-spinner.component';

@Component({
  selector: 'lib-dashboard',
  standalone: true,
  imports: [CommonModule, NavbarComponent, SidebarComponent, ScreenSpinnerComponent],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {
  companyLogoUrl = input<string>('public/shared/images/logos/isotipo.svg');
  public isSidebarOpen$: Observable<boolean>;

  constructor(private _store: Store) {
    this.isSidebarOpen$ = this._store.select(UiStore.selectors.selectIsSidebarOpen);
  }

  onToggleSidebar(): void {
    this._store.dispatch(UiStore.actions.toggleSidebar());
  }

  ngOnInit(): void {
    // Verificar el tamaño de la pantalla al iniciar
    this._checkScreenSize();
  }

  @HostListener('window:resize')
  onResize(): void {
    // Verificar el tamaño de la pantalla al redimensionar la ventana
    this._checkScreenSize();
  }

  private _checkScreenSize(): void {
    // Detectar si estamos en desktop (md: 768px en Tailwind por defecto)
    const isDesktop = window.innerWidth >= 768;
    // Si estamos en desktop y el sidebar está cerrado, abrirlo
    if (isDesktop) {
      // Verificar el estado actual del sidebar
      const subscription = this.isSidebarOpen$.subscribe({
        next: () => {
          /*if (!isOpen) {
            // Solo despachar la acción si el sidebar está cerrado
            this._store.dispatch(UiStore.actions.toggleSidebar());
          }*/
        },
        complete: () => {},
        error: () => {},
      });

      // Desuscribirse después de obtener el valor
      setTimeout(() => subscription.unsubscribe(), 0);
    }
  }
}
